export default "__VITE_ASSET__DCdKthl4__"